// extracted by mini-css-extract-plugin
export default {"row":"cartItem_row__otemx"};